import { createContext, useContext } from 'react'
import { VMPanelServerConfig } from 'common/types/VMPanelServerConfig';

export const VMPanelServerConfigContext = createContext<VMPanelServerConfig>(null)

export function useVMPanelServerConfig(): VMPanelServerConfig {
    return useContext(VMPanelServerConfigContext)
}
